import React, { useState } from 'react';
import { Form, Button, Card, Container, Spinner, Row, Col, Modal } from 'react-bootstrap';
import Swal from 'sweetalert2';
import Menu from "../../comum/Menu/menu.jsx";
import Footer from "../../comum/Footer/index.jsx";
import { api } from '../../services/api.js';
import RestauranteSelector from '../Components/CardRest/RestauranteSelector';
import CardapioPopup from '../Components/CardRest/CardapioPopup';
import imagemCupomExemplo from '../../comum/assets/cupom_exemplo.png';
import { FaReceipt, FaQuestionCircle, FaSearchPlus, FaUtensils } from 'react-icons/fa';

const RestauranteAvulso = () => {
  const [loja, setLoja] = useState('');
  const [caixa, setCaixa] = useState('');
  const [coo, setCoo] = useState('');
  const [primeiroNome, setPrimeiroNome] = useState('');
  const [ultimoNome, setUltimoNome] = useState('');
  const [cupomValido, setCupomValido] = useState(false);
  const [loading, setLoading] = useState(false);
  const [restauranteSel, setRestauranteSel] = useState(null);
  const [showAjuda, setShowAjuda] = useState(false);
  const [zoomImagem, setZoomImagem] = useState(false);

  const lClean = parseInt(loja || '0', 10);
  const cClean = parseInt(caixa || '0', 10);
  const cooClean = parseInt(coo || '0', 10);
  const matriculaPdv = `${lClean}${cClean}${cooClean}`;

  const handleValidarCupom = async (e) => {
    e.preventDefault();

    if (!primeiroNome.trim() || !ultimoNome.trim()) {
      Swal.fire({
        icon: 'warning',
        title: 'Atenção',
        text: 'Informe o primeiro e o último nome.',
        confirmButtonColor: '#8b0000'
      });
      return;
    }

    setLoading(true);

    try {
      const res = await api.get(`/restaurante/pdv/validar?loja=${loja}&caixa=${caixa}&coo=${coo}`);
      if (res.status === 200) {
        localStorage.setItem("loja", lClean.toString());
        localStorage.setItem("chapa", matriculaPdv);

        setCupomValido(true);
        Swal.fire({
          icon: 'success',
          title: 'Cupom Localizado!',
          text: 'Selecione o restaurante e monte sua refeição.',
          confirmButtonColor: '#8b0000'
        });
      }
    } catch (err) {
      const msg = err.response?.data?.erro || 'Cupom não encontrado ou já cadastrado.';
      Swal.fire({
        icon: 'error',
        title: 'Atenção',
        text: msg,
        confirmButtonColor: '#8b0000'
      });
      setCupomValido(false);
    } finally {
      setLoading(false);
    }
  };

  const handleConfirmarPedido = async (dadosPedido) => {
    try {
      const payload = {
        loja,
        caixa,
        coo,
        nomeCliente: `${primeiroNome.trim()} ${ultimoNome.trim()}`,
        codigoRestaurante: dadosPedido.restaurante.codigo,
        marmitex: dadosPedido.marmitex,
        opcao: dadosPedido.opcao,
        turno: dadosPedido.turno,
        observacao: dadosPedido.observacao
      };

      const res = await api.post('/restaurante/pdv/confirmar', payload);
      if (res.status === 200) {
        Swal.fire({
          icon: 'success',
          title: 'Sucesso!',
          text: 'Sua refeição foi registrada com sucesso!',
          confirmButtonColor: '#8b0000'
        });
        setCupomValido(false);
        setLoja('');
        setCaixa('');
        setCoo('');
        setPrimeiroNome('');
        setUltimoNome('');
        setRestauranteSel(null);
      }
    } catch (err) {
      const msg = err.response?.data?.erro || 'Erro ao gravar pedido.';
      Swal.fire({
        icon: 'error',
        title: 'Erro',
        text: msg,
        confirmButtonColor: '#8b0000'
      });
    }
  };

  return (
    <div className="bg-light min-vh-100" style={{ paddingTop: '80px', paddingBottom: '40px' }}>
      <Menu modulo="ARBOR" />
      
      <Container className="py-3 px-3 px-md-5" style={{ maxWidth: '1280px', margin: '0 auto' }}>
        {!cupomValido ? (
          <Card className="p-3 p-sm-4 shadow-sm mx-auto border-0 rounded-4 bg-white" style={{ maxWidth: '540px' }}>
            <div className="text-center mb-3">
              <div className="d-inline-flex align-items-center justify-content-center p-3 rounded-circle bg-danger bg-opacity-10 text-danger mb-2">
                <FaReceipt size={28} />
              </div>
              <h4 className="fw-bold text-dark m-0">Validar Cupom PDV</h4>
              <small className="text-muted">Insira os dados da sua compra para liberar a refeição</small>
            </div>

            <Form onSubmit={handleValidarCupom}>
              <Row className="g-2">
                <Col xs={12} sm={6}>
                  <Form.Group className="mb-2">
                    <Form.Label className="fw-semibold extra-small text-muted">Primeiro Nome</Form.Label>
                    <Form.Control 
                      type="text" 
                      value={primeiroNome} 
                      onChange={e => setPrimeiroNome(e.target.value)} 
                      required 
                      placeholder="Ex: João"
                      className="form-control-sm"
                    />
                  </Form.Group>
                </Col>
                <Col xs={12} sm={6}>
                  <Form.Group className="mb-2">
                    <Form.Label className="fw-semibold extra-small text-muted">Último Nome</Form.Label>
                    <Form.Control 
                      type="text" 
                      value={ultimoNome} 
                      onChange={e => setUltimoNome(e.target.value)} 
                      required 
                      placeholder="Ex: Silva" 
                      className="form-control-sm"
                    />
                  </Form.Group>
                </Col>
              </Row>

              <Row className="g-2">
                <Col xs={4}>
                  <Form.Group className="mb-2">
                    <Form.Label className="fw-semibold extra-small text-muted">Loja (LJ)</Form.Label>
                    <Form.Control 
                      type="number" 
                      value={loja} 
                      onChange={e => setLoja(e.target.value)} 
                      required 
                      placeholder="Ex: 5" 
                      className="form-control-sm text-center"
                    />
                  </Form.Group>
                </Col>
                <Col xs={4}>
                  <Form.Group className="mb-2">
                    <Form.Label className="fw-semibold extra-small text-muted">Caixa/PDV</Form.Label>
                    <Form.Control 
                      type="number" 
                      value={caixa} 
                      onChange={e => setCaixa(e.target.value)} 
                      required 
                      placeholder="Ex: 11" 
                      className="form-control-sm text-center"
                    />
                  </Form.Group>
                </Col>
                <Col xs={4}>
                  <Form.Group className="mb-2">
                    <Form.Label className="fw-semibold extra-small text-muted">DOC / COO</Form.Label>
                    <Form.Control 
                      type="number" 
                      value={coo} 
                      onChange={e => setCoo(e.target.value)} 
                      required 
                      placeholder="Ex: 8896" 
                      className="form-control-sm text-center"
                    />
                  </Form.Group>
                </Col>
              </Row>

              <div className="text-center my-3">
                <Button 
                  variant="link" 
                  className="p-0 text-decoration-none fw-semibold text-danger d-inline-flex align-items-center gap-1" 
                  style={{ fontSize: '0.85rem' }}
                  onClick={() => setShowAjuda(true)}
                >
                  <FaQuestionCircle size={14} />
                  Onde encontrar estes dados no cupom?
                </Button>
              </div>

              <Button 
                type="submit" 
                className="w-100 py-2 fw-bold border-0 rounded-3" 
                style={{ background: 'linear-gradient(135deg, #8b0000 0%, #c0392b 100%)' }}
                disabled={loading}
              >
                {loading ? <Spinner size="sm" animation="border" /> : 'Buscar Refeição'}
              </Button>
            </Form>
          </Card>
        ) : (
          <>
            <div className="d-flex align-items-center mb-4">
              <FaUtensils className="me-2 text-danger fs-3" />
              <div>
                <h4 className="fw-bold m-0 text-dark">Selecione seu Restaurante</h4>
                <small className="text-muted">Cliente: {primeiroNome} {ultimoNome} • Cupom validado com sucesso</small>
              </div>
            </div>

            <RestauranteSelector 
              usuario={matriculaPdv} 
              onSelecionar={setRestauranteSel} 
              bloqueado={false} 
            />
            {restauranteSel && (
              <CardapioPopup
                usuario={matriculaPdv}
                restaurante={restauranteSel}
                onClose={() => setRestauranteSel(null)}
                onConfirm={handleConfirmarPedido}
                onCancelar={() => setRestauranteSel(null)}
              />
            )}
          </>
        )}
      </Container>

      {/* Modal de Ajuda do Cupom */}
      <Modal 
        show={showAjuda} 
        onHide={() => { setShowAjuda(false); setZoomImagem(false); }} 
        centered 
        fullscreen="sm-down"
        className="rounded-4 overflow-hidden"
      >
        <Modal.Header closeButton className="border-0 pb-1">
          <Modal.Title className="h6 fw-bold text-center w-100">Onde localizar no cupom</Modal.Title>
        </Modal.Header>
        <Modal.Body className="p-3 text-center d-flex flex-column justify-content-center">
          <p className="text-muted small mb-2">
            Localize a Loja, o Caixa e o COO no cabeçalho ou rodapé do seu cupom:
          </p>
          
          <div 
            className="w-100 rounded border bg-white p-2 shadow-sm overflow-auto"
            style={{ maxHeight: zoomImagem ? '60vh' : 'auto', cursor: 'pointer' }}
            onClick={() => setZoomImagem(!zoomImagem)}
          >
            <img 
              src={imagemCupomExemplo} 
              alt="Exemplo do Cupom PDV" 
              className="img-fluid"
              style={{ 
                minWidth: zoomImagem ? '220%' : '100%', 
                transition: 'min-width 0.3s ease-in-out',
                display: 'block',
                margin: '0 auto'
              }}
            />
          </div>
          <small className="text-danger mt-2 fw-semibold d-inline-flex align-items-center justify-content-center gap-1" style={{ fontSize: '0.78rem' }}>
            <FaSearchPlus />
            {zoomImagem ? 'Toque para diminuir' : 'Toque para ampliar'}
          </small>
        </Modal.Body>
        <Modal.Footer className="border-0 pt-0">
          <Button 
            className="w-100 fw-bold py-2 rounded-3 border-0" 
            style={{ background: 'linear-gradient(135deg, #8b0000 0%, #c0392b 100%)' }}
            onClick={() => { setShowAjuda(false); setZoomImagem(false); }}
          >
            Entendi
          </Button>
        </Modal.Footer>
      </Modal>

      <Footer />
    </div>
  );
};

export default RestauranteAvulso;